import React from "react";
import "./InputTextarea.scss";
import { useTranslation } from "react-i18next";

type InputTextareaProps = {
    label?: string;
    placeholder?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    disabled?: boolean;
    error?: boolean;
    rows?: number;
    className?: string;
    required?: boolean;
};

const InputTextarea: React.FC<InputTextareaProps> = ({
    label,
    placeholder: placeholderProp,
    value,
    onChange,
    disabled = false,
    error = false,
    rows = 4,
    className = "",
    required = false,
}) => {
    const { t } = useTranslation();
    const placeholder = placeholderProp ?? (t("ui.inputs.writeHere") ?? "");
    return (
        <div className={`input-textarea-container`}>
            {label && <label className="input-textarea-label">{label}
                {required && <span className="input-dropdown__required">*</span>}
                </label>}
            <textarea
                className={`input-textarea ${error ? "error" : ""} ${className}`}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                disabled={disabled}
                rows={rows}
                required={required}
            />
            {error && (
                <p className="input-textarea-error">
                    Este campo es obligatorio
                </p>
            )}
        </div>
    );
};

export default InputTextarea;
